<div class="container">
  <div *ngIf="!showResendEmailBox" class="col-md-6 mx-auto corporate-register">
    <form [formGroup]="individualForm" (ngSubmit)="individualSubmit()">
      <div class="form-group d-flex">
        <div class="col-4 p-0">
          <mat-form-field [ngClass]="{
                  'is-invalid': !titleICtrl.valid && titleICtrl.touched,
                  'is-valid': titleICtrl.valid && titleICtrl.touched
                }">
            <mat-select placeholder="Title" formControlName="title" npDetectFocus #ipITitle="detectFocus">
              <mat-option *ngFor="let title1 of titles" [value]="title1">
                {{ title1.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div *ngIf="!titleICtrl.valid && titleICtrl.touched && !ipITitle.isFocus">
            <p class="error-message">Please enter valid information here</p>
          </div>
        </div>

        <div class="col-8 pr-0">
          <mat-form-field [ngClass]="{
                  'is-invalid': !firstNameICtrl.valid && firstNameICtrl.touched,
                  'is-valid': firstNameICtrl.valid && firstNameICtrl.touched
                }">
            <input type="text" class="capitalize-field" matInput placeholder="First Name" formControlName="firstName" npDetectFocus #ipIFName="detectFocus" maxlength="255"/>
          </mat-form-field>
          <div *ngIf="firstNameICtrl.hasError('required') && firstNameICtrl.touched && !ipIFName.isFocus" class="error-message">
            Please enter valid information here
          </div>
          <div *ngIf="firstNameICtrl.hasError('pattern') && firstNameICtrl.touched && !ipIFName.isFocus" class="error-message">
            {{ commonMessages.ruleForUserNameField }}
          </div>
        </div>
      </div>

      <div class="form-group">
        <mat-form-field [ngClass]="{
          'is-invalid': !middleNameICtrl.valid && middleNameICtrl.touched,
          'is-valid': middleNameICtrl.valid && middleNameICtrl.touched
        }">
          <input matInput class="capitalize-field" placeholder="Middle Name(s)" formControlName="middleName" type="text" npDetectFocus #ipMiddleName="detectFocus" maxlength="255"/>
        </mat-form-field>
        <span class="optional">Optional</span>
        <div *ngIf="!middleNameICtrl.valid && middleNameICtrl.touched && !ipMiddleName.isFocus" class="error-message">
          {{ commonMessages.ruleForUserNameField }}
        </div>
      </div>

      <div class="form-group">
        <mat-form-field [ngClass]="{
                'is-invalid': !lastNameICtrl.valid && lastNameICtrl.touched,
                'is-valid': lastNameICtrl.valid && lastNameICtrl.touched
              }">
          <input matInput class="capitalize-field" placeholder="Last Name" formControlName="lastName" npDetectFocus #ipILName="detectFocus" maxlength="255"/>
        </mat-form-field>
        <div *ngIf="lastNameICtrl.hasError('required') && lastNameICtrl.touched && !ipILName.isFocus" class="error-message">
          Please enter valid information here
        </div>
        <div *ngIf="lastNameICtrl.hasError('pattern') && lastNameICtrl.touched && !ipILName.isFocus" class="error-message">
          {{ commonMessages.ruleForUserNameField }}
        </div>
      </div>

      <div class="form-group">
        <mat-form-field [ngClass]="{
                'is-invalid': (!emailICtrl.valid && emailICtrl.touched && !ipIEmail.isFocus) || (emailICtrl.valid && individualForm.hasError('emailnotmatch') && confirmEmailICtrl.value && !ipIEmail.isFocus && !ipICEmail.isFocus),
                'is-valid': emailICtrl.valid && !individualForm.hasError('emailnotmatch') && !ipIEmail.isFocus && !ipICEmail.isFocus
              }">
          <input matInput placeholder="Email" formControlName="email" type="email" npDetectFocus #ipIEmail="detectFocus" />
        </mat-form-field>
      </div>
      <div *ngIf="!emailICtrl.valid && emailICtrl.touched && !ipIEmail.isFocus">
        <p class="error-message">Please enter valid information here</p>
      </div>

      <div class="form-group">
        <mat-form-field [ngClass]="{
                'is-invalid': individualForm.hasError('emailnotmatch') && emailICtrl.valid && confirmEmailICtrl.touched && !ipIEmail.isFocus && !ipICEmail.isFocus,
                'is-valid': emailICtrl.valid && !individualForm.hasError('emailnotmatch') && !ipIEmail.isFocus && !ipICEmail.isFocus
            }">
          <input matInput placeholder="Confirm Email" formControlName="confirmEmail" type="email" npDetectFocus #ipICEmail="detectFocus"
          />
        </mat-form-field>
        <div class="error-message" *ngIf="emailICtrl.valid && !confirmEmailICtrl.value && !ipICEmail.isFocus && !ipIEmail.isFocus">
          Please confirm your email
        </div>
        <div class="error-message" *ngIf="emailICtrl.valid && individualForm.hasError('emailnotmatch') && confirmEmailICtrl.value && !ipICEmail.isFocus && !ipIEmail.isFocus">
          Email and Confirm email do not match.
        </div>
      </div>

      <div class="form-group">
        <mat-form-field [ngClass]="{
                  'is-invalid': ((!pinCodeICtrl.valid || wrongPin) && pinCodeICtrl.touched && !ipIPin.isFocus) || (individualForm.hasError('pinnotmatch') && confirmPinICtrl.value && pinCodeICtrl.valid && !ipICPin.isFocus && !ipIPin.isFocus),
                  'is-valid': pinCodeICtrl.valid && !wrongPin && !individualForm.hasError('pinnotmatch') && !ipICPin.isFocus && !ipIPin.isFocus
                }">
          <input matInput placeholder="Create your 6 digit Memorable Number" formControlName="pinCode" type="password" npDetectFocus
            #ipIPin="detectFocus" maxlength="6" (keypress)="(($event.charCode >= 48 && $event.charCode <= 57) || $event.charCode === 0)"
          />
        </mat-form-field>
        <div *ngIf="pinCodeICtrl.hasError('required') && pinCodeICtrl.touched && !ipIPin.isFocus">
          <p class="error-message">Please enter valid information here</p>
        </div>
        <div class="error-message" *ngIf="(wrongPin || pinCodeICtrl.hasError('minlength')) && !ipIPin.isFocus">
          Memorable Number has 6 numeric characters and no repetition or sequencing.
        </div>
      </div>

      <div class="form-group">
        <mat-form-field [ngClass]="{
                    'is-invalid': individualForm.hasError('pinnotmatch') && confirmPinICtrl.touched && pinCodeICtrl.valid && !wrongPin && !ipICPin.isFocus && !ipIPin.isFocus,
                    'is-valid': !individualForm.hasError('pinnotmatch') && pinCodeICtrl.valid && !wrongPin && !ipICPin.isFocus && !ipIPin.isFocus
                  }">
          <input matInput placeholder="Confirm 6 digit Memorable Number" formControlName="confirmPin" type="password" npDetectFocus
            #ipICPin="detectFocus" maxlength="6" (keypress)="(($event.charCode >= 48 && $event.charCode <= 57) || $event.charCode === 0)"
          />
        </mat-form-field>
        <div class="error-message" *ngIf="!confirmPinICtrl.value && confirmPinICtrl.touched && pinCodeICtrl.valid && !wrongPin && !ipICPin.isFocus && !ipIPin.isFocus">
          Please confirm your memorable number
        </div>
        <div class="error-message" *ngIf="confirmPinICtrl.value && individualForm.hasError('pinnotmatch') && pinCodeICtrl.valid && !wrongPin && !ipICPin.isFocus && !ipIPin.isFocus">
          Memorable number and Confirm memorable number do not match
        </div>
      </div>

      <div class="form-group">
        <mat-form-field [ngClass]="{
                      'is-invalid': (!passwordICtrl.valid && passwordICtrl.touched && !ipIPass.isFocus) || (individualForm.hasError('passnotmatch') && confirmPassICtrl.value && passwordICtrl.valid && !ipICPass.isFocus && !ipIPass.isFocus),
                      'is-valid': passwordICtrl.valid && !individualForm.hasError('passnotmatch') && !ipICPass.isFocus && !ipIPass.isFocus
                    }">
          <input matInput placeholder="Create your Password" formControlName="password" type="password" (keypress)="($event.charCode !== 32)"
            npDetectFocus #ipIPass="detectFocus" />
        </mat-form-field>
        <div *ngIf="passwordICtrl.hasError('required') && passwordICtrl.touched && !ipIPass.isFocus">
          <p class="error-message">Please enter valid information here</p>
        </div>
        <div *ngIf="passwordICtrl.hasError('pattern') && !ipIPass.isFocus">
          <p class="error-message">
            The password must be at least 8 characters and must contain at least one number, one upper case character and one special
            character.
          </p>
        </div>
      </div>

      <div class="form-group">
        <mat-form-field [ngClass]="{
                        'is-invalid': individualForm.hasError('passnotmatch') && passwordICtrl.valid && confirmPassICtrl.touched && !ipICPass.isFocus && !ipIPass.isFocus,
                        'is-valid': !individualForm.hasError('passnotmatch') && passwordICtrl.valid && !ipICPass.isFocus && !ipIPass.isFocus
                      }">
          <input matInput placeholder="Confirm your Password" formControlName="confirmPass" type="password" npDetectFocus #ipICPass="detectFocus"
          />
        </mat-form-field>
        <div *ngIf="!confirmPassICtrl.value && confirmPassICtrl.touched && passwordICtrl.valid && !ipICPass.isFocus && !ipIPass.isFocus">
          <p class="error-message">Please confirm your password</p>
        </div>
        <div class="error-message" *ngIf="individualForm.hasError('passnotmatch') && confirmPassICtrl.value && passwordICtrl.valid && !ipICPass.isFocus && !ipIPass.isFocus">
          Password and Confirm password do not match
        </div>
      </div>

      <ng-container *ngIf="customerTypeNumber === 2">
        <div class="form-group">
          <mat-form-field [ngClass]="{'is-valid': individualForm.get('partnerResidency').valid && individualForm.get('partnerResidency').touched}">
            <mat-select placeholder="What is the residency of the partner" formControlName="partnerResidency">
              <mat-option *ngFor="let partnerResidency of partnerResidencies" [value]="partnerResidency.id">
                <span class="ml-3">{{ partnerResidency.name }}</span>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div>
          <mat-checkbox class="break-line greengo" disableRipple [checked]="isVATRegistered" (change)="isVATRegistered = !isVATRegistered">Are you/Is the Company (dependant on if individual or corporate registration) VAT registered?</mat-checkbox>
        </div>
        <div class="form-group" *ngIf="isVATRegistered">
          <mat-form-field [ngClass]="{'is-valid': individualForm.get('vatNumber').valid && individualForm.get('vatNumber').touched}">
            <input matInput placeholder="VAT number" formControlName="vatNumber" />
          </mat-form-field>
        </div>
        <div class="form-group" *ngIf="isVATRegistered">
          <mat-form-field [ngClass]="{'is-valid': individualForm.get('vatCountry').valid && individualForm.get('vatCountry').touched}">
            <mat-select placeholder="VAT country" formControlName="vatCountry">
              <mat-option *ngFor="let country of countries" [value]="country.code">
                <span class="ml-3">{{ country.name }}</span>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </ng-container>

      <mat-checkbox class="break-line greengo" disableRipple [checked]="acceptMarketingEmails" (change)="acceptMarketingEmails = !acceptMarketingEmails">Yes, I would like to be sent marketing communications and updates.</mat-checkbox>
      <div class="form-group">
        <mat-checkbox class="greengo" disableRipple [checked]="acceptPolicy" (change)="acceptPolicy = !acceptPolicy">Accept
          <a target="_blank" rel="noopener noreferrer" href="https://www.{{domain}}/privacy-policy" class="privacy-policy">Privacy & Cookie</a>
          policy
        </mat-checkbox>
        <div class="error-message" *ngIf="!acceptPolicy && submitForm">
          Please accept the Privacy & Cookie Policy to Proceed
        </div>
      </div>

      <div class="form-group">
        <re-captcha #captchaRef="reCaptcha" formControlName="recaptchaReactive" [siteKey]="recaptchaV2SiteKey" (resolved)="resolvedRecaptchaChallenge($event)">
        </re-captcha>
      </div>

      <button type="submit" class="btn btn-lg btn-block" [ngClass]="{
          'btn-greengo': individualForm.valid && !wrongPin && acceptPolicy,
          'btn-inactive': !individualForm.valid || wrongPin || !acceptPolicy
        }" npFocusOutClicked>Create Account</button>
    </form>
  </div>
  <div *ngIf="showResendEmailBox" class="col-md-8 col-lg-6 mx-auto verifyEmailForm">
    <div class="form-group row">
      <h6 class="fill-nightfall mx-auto">Your verification link has expired</h6>
      <div class="col-12 text-center my-3 my-md-4">
        <img class="img-fluid img-verify-email" src="/assets/images/verify-email.png" alt="{{brandName}} Verify your email">
      </div>
    </div>
    <p class="fill-nightfall text-center mb-3 mb-md-5">
      Welcome to {{brandName}}!<br>
      The verification link for your contact email address
      <strong>{{ resendEmailInfo.email }}</strong> has expired. Please click the button below to receive a new email.
    </p>
    <div>
      <button class="btn btn-block btn-greengo" type="button" (click)="resendEmail()" npFocusOutClicked>Resend email</button>
    </div>
    <p class="footer">
      Go back to
      <a *ngIf="!isPrivalgoMarkets" routerLink="/auth/login" class="link">Privalgo.co.uk</a>
      <a *ngIf="isPrivalgoMarkets" routerLink="/auth/login" class="link">PrivalgoMarkets.co.uk</a>
    </p>
  </div>
</div>   